<template>
    <div>
        <el-drawer
            :visible.sync="showModal" 
            size="50%"
        >   
            <template v-if="distributor" slot="title">
                <div class="d-flex align-items-center justify-content-between mr-3">
                    <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                        <el-tag type="primary" class="rounded-circle">
                            <i class="el-icon-office-building"></i>
                        </el-tag>
                        <h5 class="font-weight-semibold mb-0">{{ distributor.nome }}</h5>
                    </div>

                    <el-tag :type="getEventColorByStatus(distributor.status)">
                        {{ distributor.status }}
                    </el-tag>
                </div>
            </template>

            <div v-if="distributor" class="d-flex flex-column justify-content-between px-4 pb-3" :style="{ gap: '12px', height: '100%' }">
                <div>
                    <el-descriptions title="Dados" :column="6" size="mini" :border="true" class="my-3">
                        <template slot="extra">
                            <div class="d-flex" :style="{ gap: '12px'}">
                                <el-popover placement="bottom-end" trigger="click" v-model="popStatusShow">
                                    <el-button
                                        slot="reference"
                                        size="small" 
                                        type="warning" 
                                        plain 
                                    >
                                        <i class="el-icon-edit"></i>
                                        Alterar Status
                                    </el-button>

                                    <div>
                                        <el-form label-position="top">
                                            <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                                <i class="el-icon-news"></i>
                                                <label>Status Atual</label>
                                            </div>
                                            <el-select
                                                size="small"
                                                v-model="payload.status"
                                                placeholder="Selecionar status"
                                                filterable 
                                            >
                                                <el-option
                                                    v-for="(stat) in status"
                                                    :key="stat.value"
                                                    :value="stat.value"
                                                    :label="stat.text"
                                                >
                                                    <div class="d-flex align-items-center">
                                                        <el-tag 
                                                            v-if="stat.value != null"
                                                            :type="getEventColorByStatus(stat.value)" 
                                                            size="mini"
                                                            :style="{ width: '20px' }"
                                                            class="rounded-circle mr-2"
                                                        >
                                                        </el-tag>
                                                        {{ stat.text }}
                                                    </div>
                                                </el-option>
                                            </el-select>

                                            <div class="d-flex align-items-center justify-content-end">
                                                <el-button 
                                                    type="primary"
                                                    plain
                                                    size="mini"
                                                    class="mt-3"
                                                    :disabled="isLoading"
                                                    @click="onSubmit"
                                                >
                                                    <i class="fas fa-check-circle"></i>
                                                    Salvar
                                                </el-button>
                                            </div>
                                        </el-form>
                                    </div>
                                </el-popover>

                                <el-button 
                                    type="success" 
                                    plain
                                    size="small"
                                    @click="handleImport"
                                    class="mr-2"
                                >
                                    <i class="el-icon-right"></i>
                                    <i class="el-icon-folder-opened"></i>
                                    Importar
                                </el-button>
                            </div>
                        </template>

                        <!-- Nome -->
                        <el-descriptions-item :span="6">
                            <template slot="label">Nome</template>
                            <div class="d-flex align-items-center justify-content-between">
                                <span v-if="distributor.nome">{{ distributor.nome }}</span>
                                <span v-else>-</span>
                            </div>
                        </el-descriptions-item>

                        <!-- CNPJ -->
                        <el-descriptions-item 
                            :span="6"
                        >
                            <template slot="label">CNPJ</template>
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <span v-if="distributor.cnpj">{{ distributor.cnpj }}</span>
                                    <span v-else>-</span>
                                </div>                
                                <!-- <el-button v-if="distributor.cnpj && distributor.cnpj" size="mini" circle @click="copyThis(distributor.cnpj)">
                                    <i class="el-icon-document-copy"></i>
                                </el-button> -->
                            </div>
                        </el-descriptions-item>

                        <!-- E-mail -->
                        <el-descriptions-item :span="6">
                            <template slot="label">E-mail</template>
                            <span v-if="distributor.email">{{ distributor.email }}</span>
                            <span v-else>-</span>
                        </el-descriptions-item>

                        <!-- Telefone -->
                        <el-descriptions-item :span="3">
                            <template slot="label">Telefone</template>
                            <el-tag v-if="distributor.telefone" size="mini" type="primary">
                                {{ distributor.telefone }}
                            </el-tag>
                            <span v-else>-</span>
                        </el-descriptions-item>

                        <!-- CEP -->
                        <el-descriptions-item :span="3">
                            <template slot="label">CEP</template>
                            <span v-if="distributor.cep">{{ distributor.cep }}</span>
                            <span v-else>-</span>
                        </el-descriptions-item>

                        <!-- Cidade/Estado -->
                        <el-descriptions-item :span="3" label="Cidade/Estado">
                            <span v-if="distributor.cidade">{{ distributor.cidade }} - {{ distributor.estado }}</span>
                        </el-descriptions-item>
                    </el-descriptions>

                    <div class="d-flex align-items-center justify-content-between mt-3">
                        <span>Criado em:</span>
                        <div class="d-flex align-items-center justify-content-center">
                            <i class="el-icon-time"></i>
                            <span class="ml-1">{{ formatDate(distributor.created_at) }}</span>
                        </div>
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-end">
                    <el-button 
                        plain
                        @click="toggleModal"
                    >
                        Cancelar
                    </el-button>
                </div>
            </div>

            <el-empty v-else description="Distribuidor indisponível"></el-empty>
        </el-drawer>
    </div>
</template>

<script>
    // Components
    import {
        Loading,
        Row,
        Col,
        Button,
        Notification,
        Tag,
        Drawer,
        Tabs,
        TabPane,
        Card,
        Descriptions,
        DescriptionsItem,
        Divider,
        Empty,
        Popover,
        Form,
        Select,
        Option
    } from "element-ui";

    // Utis
    import { formatDate, formattedDiffDate } from "@/util/formatters";
    import { validateMin } from "@/schemas/generalSchema";

    //Api
    import { DistribuidorIndicadoApi } from "@/api/DistribuidorIndicadoApi";

    const distribuidorIndicadoApi = new DistribuidorIndicadoApi();

    export default {
        data() {
            return {
                distributorId: null,
                distributor: null,
                payload: null,
                showModal: false,
                isLoading: false,
                payload: {
                    status: null
                },
                status: [
                    { value: "IMPORTADO", text: "Importado" },
                    { value: "PENDENTE", text: "Pendente" },
                    { value: "FALHA_CONTATO", text: "Falha no contato" },
                ],
                popStatusShow: false,
            }
        }, 
        methods: {
            async show() {
                try {

                    const res = await distribuidorIndicadoApi.show(this.distributorId);

                    this.distributor = res;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o distribuidor indicado. Algo inesperado ocorreu!'
                    });
                }
            },
            async onSubmit() {
                const elLoading = this.$loading({
                    customClass: 'loader-indicative-bottom-left'
                })

                try {
                    this.isLoading = true;

                    await distribuidorIndicadoApi.update({
                        status: this.payload.status,
                    }, this.distributorId);

                    Notification.success({
                        title: 'Sucesso',
                        message: 'Status atualizado!',
                        position: 'top-left'
                    });

                    await this.show();
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível atualizar o status!',
                        position: 'top-left'
                    });
                } finally {
                    this.handleDispatch();
                    this.isLoading = false;
                    this.popStatusShow = false;
                    elLoading.close()
                }
            },
            async importDistributor() {
                try {
                    this.payload = this.distributor;
                    this.$set(this.payload, 'status', 1);
                    this.$set(this.payload, 'precadastro_id', this.distributor.id);
                    this.$set(this.payload, 'desconto', 30);
                    this.$set(this.payload, 'contatos', [
                        {
                            tipo: "F",
                            numero: this.distributor.telefone,
                            whatsapp: 0,
                        },
                    ]);

                    localStorage.distribuidorIndicado = JSON.stringify(this.payload);

                    this.$emit("dispatchImportDistributor");
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível importar o distribuidor!',
                        position: 'top-left'
                    });
                } 
            },
            handleImport() { 
                this.$confirm('Deseja importar esse distribuidor?', 'Confirmação importação', {
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Cancelar',
                }).then(async () => {
                    await this.importDistributor();

                    this.toggleModal(); 

                }).finally(() => {
                    this.handleDispatch()
                })
            },
            toggleModal() {
                this.showModal = !this.showModal;
            },
            handleDispatch() {
                this.$emit('dispatch');
            },
            getEventColorByStatus(status) {
                switch(status) {
                    case 'IMPORTADO':
                        return 'success'
                    case 'PENDENTE':
                        return 'warning'
                    case 'FALHA_CONTATO':
                        return 'danger' 
                    default: 
                        return 'info'
                }
            },
            formattedDiffDate,
            formatDate,
            validateMin
        },
        computed: {
            getUserId() {
                return this.$store.getters['user/getUserId']
            },  
            isAuthorized() {
                return this.$store.getters['user/isAnyRole']([
                    'adm',
                    'coord_comercial',
                ]);
            },
        },
        watch: {
            "distributor": {
                handler(_newValue) {
                    this.$set(this.payload, 'status', _newValue.status)
                }
            }
        },
        components: {
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Button.name]: Button,
            [Tag.name]: Tag,
            [Drawer.name]: Drawer,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
            [Card.name]: Card,
            [Descriptions.name]: Descriptions,
            [DescriptionsItem.name]: DescriptionsItem,
            [Divider.name]: Divider,
            [Empty.name]: Empty,
            [Popover.name]: Popover,
            [Form.name]: Form,
            [Select.name]: Select,
            [Option.name]: Option,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/indicados/distribuidores_indicados/DistributorShowModal.vue